import React, {useEffect, useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';

const authHeader = () => ({Authorization: `Bearer ${localStorage.getItem('token') || ''}`});

function fmtDT(v) {
    try {
        return new Intl.DateTimeFormat('pl-PL', {dateStyle: 'medium', timeStyle: 'short'}).format(new Date(v));
    } catch {
        return v || '—';
    }
}

export default function Exams() {
    const nav = useNavigate();
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');
    const [items, setItems] = useState([]);
    const [titleNew, setTitleNew] = useState('');
    const [busyCreate, setBusyCreate] = useState(false);
    const [busyId, setBusyId] = useState(null); // dla duplikuj/usuń

    const load = async () => {
        setErr('');
        setLoading(true);
        try {
            const r = await fetch('/api/prowadzacy/egzaminy', {credentials: 'include', headers: {...authHeader()}});
            if (!r.ok) throw new Error((await r.json().catch(() => ({})))?.blad || `Błąd (${r.status})`);
            const j = await r.json();
            setItems(Array.isArray(j) ? j : []);
        } catch (e) {
            setErr(e.message || 'Błąd pobierania');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, []);

    const createExam = async () => {
        if (!titleNew.trim()) return;
        setBusyCreate(true);
        setErr('');
        try {
            const r = await fetch('/api/prowadzacy/egzaminy', {
                method: 'POST',
                credentials: 'include',
                headers: {'Content-Type': 'application/json', ...authHeader()},
                body: JSON.stringify({title: titleNew.trim()})
            });
            const j = await r.json().catch(() => ({}));
            if (!r.ok) throw new Error(j?.blad || `Błąd tworzenia (${r.status})`);
            setTitleNew('');
            // przejście od razu do buildera, jak chciałeś
            nav(`/prowadzacy/egzamin/${j.exam_id}/builder`);
        } catch (e) {
            setErr(e.message || 'Błąd tworzenia');
        } finally {
            setBusyCreate(false);
        }
    };

    const duplicateExam = async (examId) => {
        setBusyId(examId);
        setErr('');
        try {
            const r = await fetch(`/api/prowadzacy/egzamin/${examId}/duplikuj`, {
                method: 'POST', credentials: 'include', headers: {...authHeader()}
            });
            const j = await r.json().catch(() => ({}));
            if (!r.ok) throw new Error(j?.blad || `Błąd duplikacji (${r.status})`);
            // opcja A: od razu do buildera kopii
            nav(`/prowadzacy/egzamin/${j.exam_id}/builder`);
            // opcja B: przeładuj listę
            // await load();
        } catch (e) {
            setErr(e.message || 'Błąd duplikacji');
        } finally {
            setBusyId(null);
        }
    };

    const deleteExam = async (examId) => {
        const txt = window.prompt('Aby usunąć egzamin wpisz: tak');
        if ((txt || '').trim().toLowerCase() !== 'tak') return;
        setBusyId(examId);
        setErr('');
        try {
            const r = await fetch(`/api/prowadzacy/egzamin/${examId}`, {
                method: 'DELETE', credentials: 'include', headers: {...authHeader()}
            });
            const j = await r.json().catch(() => ({}));
            if (!r.ok) throw new Error(j?.blad || `Błąd usuwania (${r.status})`);
            await load();
        } catch (e) {
            setErr(e.message || 'Błąd usuwania');
        } finally {
            setBusyId(null);
        }
    };

    return (
        <div style={{padding: '0 16px', marginTop: 80}}>
            <h1 style={{marginBottom: 16}}>Egzaminy</h1>
            <div style={{
                marginTop: '2rem',
                border: '1px solid #e5e7eb',
                borderRadius: 12,
                padding: 14,
                background: '#fff'
            }}>
                <h3 style={{marginTop: 0}}>Utwórz nowy egzamin</h3>
                <div style={{display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap'}}>
                    <input
                        type="text"
                        placeholder="Tytuł egzaminu"
                        value={titleNew}
                        onChange={e => setTitleNew(e.target.value)}
                        style={{flex: '1 1 300px', padding: '8px 10px', border: '1px solid #e5e7eb', borderRadius: 8}}
                    />
                    <button
                        className={'but-smal'}
                        disabled={busyCreate || !titleNew.trim()}
                        onClick={createExam}
                        style={{
                            border: 'none',
                            borderRadius: 8,
                            padding: '8px 12px',
                            boxShadow: 'none',
                            opacity: busyCreate ? 0.7 : 1
                        }}
                    >
                        Utwórz
                    </button>
                </div>
                <div style={{fontSize: 12, color: '#6b7280', marginTop: 6}}>
                    Po utworzeniu przejdziesz bezpośrednio do kreatora.
                </div>
            </div>

            {/* Kafelkowy grid egzaminów */}
            {loading ? (
                <div>Ładowanie…</div>
            ) : err ? (
                <div style={{color: 'crimson', marginBottom: 12}}>{err}</div>
            ) : items.length === 0 ? (
                <div style={{
                    border: '1px dashed #d1d5db',
                    borderRadius: 12,
                    padding: 20,
                    color: '#6b7280',
                    marginBottom: 16
                }}>
                    Brak egzaminów. Utwórz swój pierwszy egzamin poniżej.
                </div>
            ) : (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                    gap: 12, marginBottom: 20
                }}>
                    {items.map(ex => (
                        <div key={ex.exam_id}
                             style={{
                                 border: '1px solid #e5e7eb', borderRadius: 12, padding: 14, background: '#fff',
                                 display: 'grid', gap: 8
                             }}>
                            <div style={{fontWeight: 700, fontSize: 18}}>{ex.title}</div>
                            <div style={{color: '#6b7280', fontSize: 13}}>
                                Utworzono: {fmtDT(ex.created_at)}<br/>
                                Sekcje: {ex.sections_count ?? 0} • Pytania: {ex.questions_count ?? 0} •
                                Terminy: {ex.terms_count ?? 0}
                            </div>

                            <div style={{display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 6}}>
                                <button
                                    className={'but-smal'}
                                    onClick={() => nav(`/prowadzacy/egzamin/${ex.exam_id}/builder`)}
                                    style={{
                                        border: '1px solid #e5e7eb',
                                        borderRadius: 8,
                                    }}
                                >
                                    Edytuj
                                </button>
                                <button
                                    className={'but-smal'}
                                    onClick={() => nav(`/prowadzacy/egzamin/${ex.exam_id}/terminy`)}
                                    style={{
                                        border: '1px solid #e5e7eb',
                                        borderRadius: 8,
                                    }}
                                >
                                    Terminy
                                </button>
                                <button
                                    className={'but-smal'}
                                    disabled={busyId === ex.exam_id}
                                    onClick={() => duplicateExam(ex.exam_id)}
                                    style={{
                                        border: 'none',
                                        borderRadius: 8,
                                        padding: '8px 12px',
                                        boxShadow: 'none',
                                        opacity: busyId === ex.exam_id ? 0.6 : 1
                                    }}
                                >
                                    Duplikuj
                                </button>
                                {ex.terms_count  === 0 ? (
                                    <button
                                        className={'but-smal'}
                                        disabled={busyId === ex.exam_id}
                                        onClick={() => deleteExam(ex.exam_id)}
                                        style={{
                                            border: 'none',
                                            borderRadius: 8,
                                            padding: '8px 12px',
                                            background: '#fee2e2',
                                            color: '#b91c1c',
                                            marginLeft: 'auto',
                                            opacity: busyId === ex.exam_id ? 0.6 : 1
                                        }}
                                        title="Nie można usunąć, jeśli egzamin ma już przypisane terminy"
                                    >
                                        Usuń
                                    </button>
                                ) : (
                                    <span style={{color: '#b45309', fontSize: 13}}>

                                    </span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Utwórz nowy egzamin */}

        </div>
    );
}
